export default __webpack_public_path__ + "static/media/new.a6b296ae.svg";